import React, {Component} from 'react';

class NotFound extends Component {
    state = {};

    render() {
        return (
            <div className='not-found-container text-center display-flex'>
                <div className="not-found-message">

                    <p className='m-sm-b'><span role="img" aria-label='Thinking emoji'>🤔</span></p>
                    <p>Hmmm, it seems like <br/>
                        we don't have that page! </p>

                    <h2>Continue to<a href="/dashboard"> homepage</a>.</h2>
                </div>
            </div>
        )
    }
}

export default NotFound;